import React, { forwardRef, useImperativeHandle, useEffect, useState, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//horizontalScroll
import ScrollContainer from 'react-indiana-drag-scroll';
//select
import SelectSearch from 'react-select-search';
import 'src/asset/scss/plugin/select.scss';
//styles
import styles from 'src/asset/scss/styles/userPartnerItemReg.module.scss';
//hooks
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
import useUploadFileHook from 'src/webapp/hooks/comn/uploadFile.hook';
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//store
import useAdminStore from 'src/webapp/stores/admin.store';
import useComnStore from 'src/webapp/stores/comn.store';
//CompWrapper
import Element from 'src/webapp/views/wrapper/Element';
import FormWrapper from 'src/webapp/views/wrapper/form/Form';//입력폼
import TitleWrapper from 'src/webapp/views/wrapper/form/Title';//입력폼내제목
//comp
import ImgArea from 'src/webapp/views/component/ImgArea';//상품이미지
import Button from 'src/webapp/views/component/Button';//버튼엘리먼트
// import VehicleListPopup from '../popup/VehicleList';//팝업-등록차량선택

const Form = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({//상위컴포넌트에서 호출
        onSubmitHandler
    }));
    const onSubmitHandler = () => {
        bannerRegAndUpdateAPI();
    }
    const { state } = useLocation();
    const { data, type } = props;//props
    const navigator = useNavigate();
    const FORM_CONFIG = [{ label: '제목', defaultValue: state?.TITLE ?? '', inputMode: 'none', type: 'text' }
        , { label: '보조 텍스트', defaultValue: state?.SUB_TITLE ?? '', inputMode: 'none', type: 'text' }
        , { label: '이미지 링크', defaultValue: state?.LINK_URL ?? '', inputMode: 'none', type: 'text' }
        , { label: '정렬순서', defaultValue: state?.SORT_ORDER ?? '', inputMode: 'numeric', type: 'text' }
    ];
    const inputRef = useRef([]);//입력값
    //hook
    //파일추가
    const { files, setFiles//fileuseState
        , MAX_COUNT//최대업로드갯수
        , addFilesHandler//파일업로드핸들러
    } = useUploadFileHook();
    const { axiosMultiPartHandler, axiosPostHandler } = useAxiosHook();
    //store
    const { admin } = useAdminStore();
    const { setMessage } = useComnStore();

    /* ============================ 입력값 ============================ */
    const now = new Date();//오늘자
    const sevendaysAfter = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);//7일후
    /* =============== 가입일 =============== */
    const [startDate, setStartDate] = useState(state?.START_DATE ? new Date(state.START_DATE.split(".")[0]) : now);
    const [endDate, setEndDate] = useState(state?.END_DATE ? new Date(state.END_DATE.split(".")[0]) : sevendaysAfter);
    const dateFormmat = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year + '-' + month + '-' + day}`;
    }
    /* ==================== validationCheck ==================== */
    const onValidateHandler = (index, e) => {
        if (index === 3) { e.target.value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'); }
        if (files.length <= 0) { props.onValid(null, true); return; }
        if (inputRef.current[3].value.length <= 0) { props.onValid(null, true); return; }
        if (inputRef.current[1].value.length > 0 && inputRef.current[0].value.length <= 0) { props.onValid(null, true); return; }
        if (inputRef.current[4]?.checked === false && inputRef.current[5]?.checked === false) { props.onValid(null, true); return; }
        if ((endDate.getTime() - startDate.getTime()) <= 0) { props.onValid(null, true); return; }
        props.onValid(null, false);
    }
    useEffect(() => {
        onValidateHandler();
    }, [startDate, endDate, files])
    useEffect(() => {
        if (state !== null) {
            setFiles([{ src: state.IMG_SRC, url: state.IMG_SRC }])
        }
    }, [state])
    /* ==================== validationCheck ==================== */
    const isLock = useRef(false);
    const bannerRegAndUpdateAPI = async () => {//type - 1.등록, 2.수정, 3.삭제
        try {
            const type = state ? "수정" : "등록";
            if (isLock.current) { return; }
            isLock.current = true;
            const DATA = new FormData();
            let variables = {
                SEQ_NO: state ? state.SEQ_NO : 0,      //BANNER_SEQ 시퀀스(수정시에만)
                TITLE: inputRef.current[0].value,      //제목
                SUB_TITLE: inputRef.current[1].value,   //보조텍스트
                LINK_URL: inputRef.current[2].value,   //배너 클릭 시 이동할 URL
                SORT_ORDER: inputRef.current[3].value,   //정렬 순서(낮을수록 상단/앞쪽)
                TYP: 1,      //배너 위치(1.MAIN_TOP)
                START_DATE: dateFormmat(startDate).replaceAll("-", ""),   //노출 시작일
                END_DATE: dateFormmat(endDate).replaceAll("-", ""),   //노출 종료일
                ADMIN_ID: admin.COMN_ID,   //upsert 처리 관리자아이디
                STATE: state ? 2 : 1,      //처리유형 - 1.등록, 2.수정, 3.삭제
                OVERLAY_TONE:inputRef.current[4].checked === true ? "dark" : inputRef.current[5].checked ? "light" : null
            };
            DATA.append("file", files[0].file !== undefined ? files[0].file : []);
            DATA.append('requestDTO', new Blob([JSON.stringify(variables)]), { type: "application/json" });
            const result = await axiosMultiPartHandler("siteBannerUpsertForAdmin.do", DATA);
            const isOk = result && result.message === "SUCCESS";
            if (isOk) { setMessage({ type: 1, label: `배너 ${type}이 완료되었습니다.` }); navigator(-1, { replace: true }); return; }
            setMessage({ type: 2, label: `배너 ${type}에 실패 하였습니다.` });

        } finally { isLock.current = false; }
    }


    return (
        <>
            <Element tag={`div`} className={styles.formArea}>
                <Element tag={`div`} className={styles.imgArea}>
                    {/* START 이미지 추가 */}
                    {files.length < MAX_COUNT.current ?
                        <Element tag={`div`} className={styles.fileArea}>
                            <Element tag={`label`} htmlFor="file"><Element tag={`span`}>이미지 업로드</Element><FontAwesomeIcon icon="fa-light fa-rectangle-history-circle-plus" /></Element>
                            <input onChange={(e) => addFilesHandler(e)} type="file" id="file" accept='image/webp' />
                        </Element>
                        : null}
                    {files.length > 0 && files.map((file, idx) => (
                        <React.Fragment key={idx}>
                            <Element tag={`div`} className={styles.imgPreview}>
                                <Element tag={`div`} className={styles.previewImage}><img src={file.src ? process.env.REACT_APP_IMAGE_URL + file.src : file.url} alt="preview-img" /></Element>
                                <Button anyprop={(e) => setFiles([])} icon={`fa-light fa-pen-to-square`} label={`이미지 변경하기`} />
                            </Element>
                        </React.Fragment>
                    ))}
                </Element>
                {/* END 이미지 추가 */}
                {/* START 입력필드 */}
                {/* 제품명 ~ 작업시간 */}
                {[...Array(4)].map((x, i) =>
                    <FormWrapper key={i}>
                        <TitleWrapper title={FORM_CONFIG[i].label} />
                        <input type={FORM_CONFIG[i].type} inputMode={FORM_CONFIG[i].inputMode}
                            defaultValue={FORM_CONFIG[i].defaultValue}
                            onChange={(e) => { onValidateHandler(i, e); }}
                            ref={el => (inputRef.current[i] = el)} />
                    </FormWrapper>
                )}
                <FormWrapper>
                    <TitleWrapper title={"배경컬러"} />
                    <div><input type="radio" name="BG_COLOR" className={`radio`} id="bg_color-1" ref={el => inputRef.current[4] = el} onChange={(e) => onValidateHandler()} defaultChecked={state?.OVERLAY_TONE === "dark" ? true : false} />
                        <label htmlFor="bg_color-1" className="radio-label" >dark</label></div>
                    <div><input type="radio" name="BG_COLOR" className={`radio`} id="bg_color-2" ref={el => inputRef.current[5] = el} onChange={(e) => onValidateHandler()} defaultChecked={state?.OVERLAY_TONE === "light" ? true : false} />
                        <label htmlFor="bg_color-2" className="radio-label" >light</label></div>
                </FormWrapper>
                <FormWrapper>
                    <TitleWrapper title={'노출 시작일'} />
                    <input onChange={(e) => setStartDate(new Date(e.target.value))} type="date" placeholder={'선택하세요'} value={startDate === null ? now : dateFormmat(startDate)} />
                </FormWrapper>
                <FormWrapper>
                    <TitleWrapper title={'노출 종료일'} />
                    <input onChange={(e) => setEndDate(new Date(e.target.value))} type="date" placeholder={'선택하세요'} value={endDate === null ? now : dateFormmat(endDate)} />
                </FormWrapper>
            </Element>
        </>
    );
})
export default Form;